import React from "react";
import { Menu, Segment } from "semantic-ui-react";
import { PendencyResolvableList } from "./PendencyResolvableList";
import { PendencyCancelableList } from "./PendencyCancelableList";
import { PendencyDoneList } from "./PendencyDoneList";
import {
  NavLink,
  Redirect,
  Route,
  Switch,
  useRouteMatch,
} from "react-router-dom";

function PendencyMenu() {
  const { url } = useRouteMatch();
  return (
    <Menu secondary pointing stackable>
      <Menu.Item as={NavLink} to={`${url}/resolver`}>
        Minhas pendências
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/cancelar`}>
        Minhas requisições
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/finalizadas`}>
        Pendências finalizadas
      </Menu.Item>
    </Menu>
  );
}

export const PendencyList = () => {
  const { path, url } = useRouteMatch();

  return (
    <>
      <PendencyMenu url={url} />
      <Switch>
        <Route path={`${path}/resolver`}>
          <Segment basic style={{ paddingTop: 0 }}>
            <span>
              As pendências são geradas quando há alteração de gestor para a sua
              estrutura ou estrutura que você é responsável, que precisam de sua
              validação para serem concluídas.
            </span>
            <PendencyResolvableList />
          </Segment>
        </Route>
        <Route path={`${path}/cancelar`}>
          <Segment basic style={{ paddingTop: 0 }}>
            <span>
              As requisições são geradas quando há alteração de gestor de
              pessoas da sua estrutura ou estrutura que você é responsável, que
              necessitam da aprovação de outra pessoa para que sejam concluídas.
            </span>
            <PendencyCancelableList />
          </Segment>
        </Route>
        <Route path={`${path}/finalizadas`}>
          <Segment basic style={{ paddingTop: 0 }}>
            <span>
              Pendências finalizadas são as pendências que já foram concluídas
              (aprovadas, recusadas ou canceladas).
            </span>
            <PendencyDoneList />
          </Segment>
        </Route>
        <Redirect to={`${url}/resolver`} />
      </Switch>
    </>
  );
};
